import Vue from 'vue'

const state = {
  settings: {}
}

const getters = {
  settings: (state) => state.settings
}

const actions = {
  async getSettings ({commit}, settings) {
    const {body} = await Vue.http.post('/settings', settings)
    commit('setSettings', body.data)
  },
  async saveSettings ({commit}, settings) {
    await Vue.http.put('/settings', settings)
  }
}

const mutations = {
  setSettings (state, settings) {
    state.settings = Object.assign({}, state.settings, settings)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js